<template>
  <el-dialog
    :title="activeStep == -1 ? 'Authorization Confirmation' : 'Add Asset'"
    width="960px"
    :close-on-click-modal="false"
    :visible.sync="addDeviceShow"
    @close="closePage"
  >
    <div class="sp_addDevice">
      <!-- 步骤条区域 -->
      <div class="sp_content">
        <el-row class="progress-bar" v-if="activeStep !== -1">
          <el-col :span="24">
            <el-steps :active="activeStep" align-center finish-status="success">
              <!-- <el-step title="Choose Add Device"></el-step> -->
              <el-step title="Submit Device SN or ID"></el-step>
              <el-step title="Check Device Information"></el-step>
            </el-steps>
          </el-col>
        </el-row>
        <div v-show="activeStep !== 3" class="line"></div>

        <!-- 第一步 -->
        <el-row
          class="sp_deviceStep1"
          v-if="activeStep == -1"
          type="flex"
          justify="center"
          style="flex-wrap: wrap"
        >
          <el-col
            :span="16"
            style="
              text-align: left;
              display: flex;
              align-items: center;
              margin-top: 36px;
              margin-bottom: 55px;
            "
          >
            <div style="width: 160px">Authorized Company：</div>
            <div class="sp_deviceRadio">
              <span>{{ companyName }}</span>
            </div>
          </el-col>
          <el-col
            :span="24"
            style="text-align: left; margin-top: 16px; margin-bottom: 55px"
          >
            <div class="support">
              <span style="margin-right:9px,height:24px">
                <!-- <i class="el-icon-warning-outline"></i> -->
                <svg-icon class="message-svg" icon-class="message"></svg-icon>
              </span>
              <div>
                <div class="support-tips">
                  <!-- {{
                    `Please comfirm you are the devices owner , the name of the company that performs the activation is; recorded on the device`
                  }} -->
                  Please confirm that you are the owner of the assets. The company name may be displayed on the asset(depending on the products) after it is activated.
                </div>
                <!-- <div>Support physical IAG with version 12.0.41 and above, and order should be placed after 13 June 2022.</div> -->
              </div>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="sp_deviceRadio"
                 v-for="val in radioList"
                 :key="val.id"
                 :class="{is_checked:checkRadio == val.id}"
                 @click="handleCheck(val.id)">
              <span>{{val.label}}</span>

              <svg-icon class="el-icon-check"
                        v-if="checkRadio == val.id"
                        icon-class="ok"></svg-icon>
            </div>
          </el-col> -->
          <el-col :span="24" class="footer">
            <el-button size="medium" type="primary" @click="handleNext(0)"
              >Confirm</el-button
            >
            <el-button size="medium" plain @click="closePage">Cancel</el-button>
          </el-col>
        </el-row>

        <!-- 第二步 -->
        <el-form
          :model="filter"
          ref="addDeviceFrom"
          :rules="addDeviceRules"
          class="addDeviceFrom"
          v-if="activeStep == 0"
        >
          <el-row class="add-content" v-if="checkRadio == 1">
            <el-col :span="12">
              <el-form-item label="Device ID or SN：" prop="deviceIdOrSn">
                <el-input
                  type="textarea"
                  v-model="filter.deviceIdOrSn"
                  :autosize="{ minRows: 4, maxRows: 6 }"
                  :placeholder="`One device per line. For example:\nIDAABBCC\nSN11AA22BB33\nCLOUDID11AA22BB33CC`"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="add-content" v-if="checkRadio == 2">
            <el-col :span="23">
              <el-form-item
                prop="deviceIdOrSn"
                label="Please input Device ID or SN or Cloud License ID:"
              >
                <el-input
                  size="medium"
                  :autosize="{ minRows: 5, maxRows: 7 }"
                  type="textarea"
                  v-model="filter.deviceIdOrSn"
                  :placeholder="`One device per line. For example:\nIDAABBCC\nSN11AA22BB33\nCLOUDID11AA22BB33CC`"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-tooltip class="item" effect="dark" placement="bottom">
                <svg-icon icon-class="message" style="float: right"></svg-icon>
                <div slot="content">
                  <p>
                    Support physical NGAF with version 8.0.26 and above, and
                    order should be placed after 13 Oct 2021.
                  </p>
                  <p>
                    Support physical IAG with version 12.0.41 and above, and
                    order should be placed after 13 June 2022.
                  </p>
                  <p>
                    Support Cyber Command with version 3.0.49 and above, and
                    order should be placed after 18 Sept 2023.
                  </p>
                  <p>
                    Support STA with version 3.0.37 and above, and order should
                    be placed after 18 Sept 2023.
                  </p>
                  <p>
                    Support ES with version 3.5.6 and above, and order should be
                    placed after 18 Sept 2023.
                  </p>
                  <p>
                    Support aTrust with version 2.4.10 and above, and order should
                    be placed after 6 Mar 2025.
                  </p>
                </div>
              </el-tooltip>
            </el-col>
          </el-row>
          <div
            style="
              color: #77808c;
              font-size: 14px;
              line-height: 24px;
              margin: 0 auto;
              width: 700px;
              background-color: #f5f6fa;
              padding: 0 5px;
            "
          >
            <div>
              <svg-icon class="message-svg" icon-class="message"></svg-icon>
              Please input the Cloud License ID for virtual device.
            </div>
          </div>
          <!-- <div>Support physical IAG with version 12.0.41 and above, and order should be placed after 13 June 2022.</div> -->
          <el-row
            class="add-content"
            v-if="checkRadio == 2"
            style="margin-top: 25px"
          >
            <el-col :span="24">
              <div style="display: flex">
                <el-checkbox
                  v-model="checked"
                  @change="transform"
                ></el-checkbox>
                <div style="margin-left: 5px">
                  If you have multiple assets from same order, you can input the
                  Order No. to add assets in bulk.
                </div>
              </div>
            </el-col>
          </el-row>

          <div v-show="checked">
            <el-row
              class="add-content"
              v-if="checkRadio == 2"
              style="margin: 15px auto;"
            >
              <el-col :span="24">
                <el-form-item style="margin:0">
                  <el-input
                    size="medium"
                    type="text"
                    v-model="filter.orderId"
                    placeholder="Please input Order No."
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div
              style="
                color: #77808c;
                font-size: 14px;
                line-height: 24px;
                margin: 10px auto;
                width: 700px;
                background-color: #f5f6fa;
                padding: 0 5px;
              "
            >
              <div style="display: flex">
                <div>
                  <svg-icon class="message-svg" icon-class="message"></svg-icon>
                </div>
                <div>
                  If you have any question about Order No., please contact
                  Sangfor local support team or Sangfor
                  TAC(tech.support@sangfor.com)
                </div>
              </div>
            </div>
          </div>
          <el-row class="second-footer">
            <el-form-item>
              <el-button size="medium" plain @click="handleBack(0)"
                >Back</el-button
              >
              <el-button
                size="medium"
                type="primary"
                @click="handleNext(1, 'addDeviceFrom')"
                >Next</el-button
              >
              <el-button size="medium" @click="closePage" plain
                >Cancel</el-button
              >
            </el-form-item>
          </el-row>
        </el-form>

        <!-- 第三步 -->
        <el-row v-if="activeStep == 1" class="sp_deviceStep3">
          <el-col class="device-table" :span="24">
            <el-table
              border
              style="width: 100%"
              :header-cell-style="setHeadeStyle"
              size="medium"
              :data="tableData"
              v-loading="tableLoading"
              ref="multipleTable"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                align="center"
                :selectable="selectable"
              ></el-table-column>

              <el-table-column
                label="Gateway ID"
                prop="deviceId"
              ></el-table-column>
              <el-table-column label="Serial Number">
                <template slot-scope="scope">
                  <span style="color: #007aff; cursor: pointer">{{
                    scope.row.sn
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Cloud License ID"
                prop="licenseId"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="Product"
                width="120px"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{scope.row.model.indexOf("NSF")==0 ? "NSF" : scope.row.productType}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Model"
                width="120px"
                prop="model"
              ></el-table-column>

              <el-table-column
                label="Auto Activation"
                align="left"
                show-overflow-tooltip
                :render-header="renderHeader"
              >
                <!-- <template v-slot:header>
                
                </template> -->
                <template slot-scope="scope">
                  <el-checkbox-group v-model="checkList">
                    <el-checkbox
                      :label="!scope.row.autoActivate ? '' : scope.row.id"
                      :disabled="!scope.row.autoActivate"
                      >Enable</el-checkbox
                    >
                  </el-checkbox-group>
                </template>
              </el-table-column>

              <el-table-column label="Status" width="150">
                <template slot-scope="scope">
                  <span :style="statusStyle[scope.row.licenseStatus]">{{
                    deviceStatus[scope.row.licenseStatus]
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="pageSizes"
              :page-size="filter.pageSize"
              :current-page="filter.pageNumber"
              :disabled="total < 10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </el-col>
          <el-col :span="24" class="third-footer">
            <el-button size="medium" plain @click="handleBack(1)"
              >Back</el-button
            >
            <el-button
              size="medium"
              type="primary"
              @click="handleNext(2, 'add')"
              >Save & Add more</el-button
            >
            <el-button
              size="medium"
              plain
              @click="handleNext(2)"
              :loading="saveLoding"
              >Save</el-button
            >
            <el-button size="medium" @click="closePage" plain>Cancel</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 弹出框 -->
      <el-dialog
        title="Hint"
        :visible.sync="dialogVisible"
        width="30%"
        :show-close="false"
        :modal="false"
        :close-on-click-modal="false"
      >
        <el-row class="checkJunpRadio">
          <el-col
            :class="{ activeJunpRadio: checkJunpRadio == val.id }"
            v-for="val in JunpRadio"
            :key="val.id"
          >
            <el-radio v-model="checkJunpRadio" :label="val.id">{{
              val.name
            }}</el-radio>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleConfirm">Confirm</el-button>
        </span>
      </el-dialog>
    </div>
  </el-dialog>
</template>

<script>
import headeTitle from "../../components/headeTitle.vue";
import { tableMixis } from "@/mixins/tableMixis.js";
import { addAssetApi, addConfirmApi } from "@/api/assetsList.js";
import { getCompanyInforApi } from "@/api/common.js";
export default {
  components: { headeTitle },
  name: "addDevice",
  mixins: [tableMixis],
  data() {
    return {
      checked: false,
      title: "Add Asset",
      addDeviceShow: false,
      showClose: true,
      activeStep: -1,
      filter: {
        orderId: "",
        deviceIdOrSn: "",
        deviceIdOrSnOrCloudId: "",
        pageSize: 10,
        pageNumber: 1,
      },
      defaultFilter: {},
      radioList: [
        { id: 1, label: "Add a device" },
        { id: 2, label: "Add multiple devices" },
      ],
      checkRadio: 2,
      addDeviceRules: {
        orderId: [
          {
            required: true,
            message: "Please input Order No.",
            trigger: "blur",
          },
        ],
        deviceIdOrSn: [
          {
            required: true,
            message: `Please input correct Device ID or SN or Cloud License ID.`,
            trigger: "blur",
          },
        ],
      },
      deviceStatus: {
        0: "Inactivated",
        1: "Activated",
        2: "To be Updated",
        4: "Expired",
      },
      statusStyle: {
        0: {
          background: "#F4A12D",
          color: "#fff",
          padding: "1px 10px",
          borderRadius: "25px",
        },
        1: {
          background: "#32C093",
          color: "#fff",
          padding: "1px 10px",
          borderRadius: "25px",
        },
        2: {
          background: "#007AFF",
          color: "#fff",
          padding: "1px 10px",
          borderRadius: "25px",
        },
        4: {
          background: "#79828C",
          color: "#fff",
          padding: "1px 10px",
          borderRadius: "25px",
        },
      },
      tableData: [],
      pageSizes: [10, 15, 30, 60, 100],
      total: 0,
      tableLoading: false,
      selectionData: [],
      dialogVisible: false,
      checkJunpRadio: "",
      JunpRadio: [
        { id: 1, name: "Continue to add device" },
        { id: 2, name: "View in my devices List" },
      ],
      saveLoding: false,
      checkList: [],
      companyName: "",
    };
  },

  props: {
    addDeviceVisible: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    "$store.state.user.loadAssetePage": {
      handler(val) {
        if (val) {
          this.$emit("addDeviceChildMsg", { close: false });
        }
      },
      immediate: true,
    },

    addDeviceVisible: {
      handler(val) {
        this.addDeviceShow = val;
      },
      immediate: true,
    },
  },

  methods: {
    //表头样式
    renderHeader(h, data) {
      const info =
        "Automatic Activation Enable. When Automatic Activation is enabled, the device will be activated automatically after it connects to the Internet. Automatic activation is not available for software products.";
      return h("div", [
        h("span", data.column.label),
        // placement指定悬浮显示方向
        h("el-tooltip", { props: { placement: "top", effect: "dark" } }, [
          // style 调文字颜色样式
          h("div", { slot: "content" }, info),
          // el-icon-warning是element图标, style 调图标颜色 样式
          h("i", { class: "el-icon-info", style: "margin-left:4px" }),
        ]),
      ]);
    },
    closeAddDevice() {},
    //获取公司名字
    //获取公司信息
    getCompanyInfor() {
      let params = this.$store.getters.userInfo.corpsId;
      getCompanyInforApi(params).then((res) => {
        let companyInfo = res.rows;
        this.companyName = companyInfo.name;
      });
    },

    //选择添加多个或者单个设备
    handleCheck(id) {
      this.checkRadio = id;
    },

    //点击下一步或提交
    handleNext(data, addDeviceFrom) {
      if (data == 0) {
        if (this.checkRadio !== null) {
          this.activeStep = 0;
          this.filter = JSON.parse(JSON.stringify(this.defaultFilter));
        } else {
          return;
        }
      } else if (data == 1) {
        this.$refs[addDeviceFrom].validate(async (valid) => {
          if (valid) {
            const code = await this.handleSearch(2);
            if (code == 0) this.activeStep = 1;
            this.$nextTick(() => {
              this.toggleSelection(this.tableData);
            });
          }
        });
      } else if (data == 2) {
        if (this.selectionData.length > 0) {
          let params = [];
          //这里判断一波勾选的是否有已经绑定的
          for (var i = 0; i < this.selectionData.length; i++) {
            // if (this.selectionData[i].bindingFlag) {
            //   this.$message({
            //     type: "warning",
            //     message:
            //       "The devices have been added, please do not add them repeatedly.",
            //   });
            //   params = [];
            //   break;
            // } else {
            //   params.push(this.selectionData[i].id);
            // }
            params.push(this.selectionData[i].id);
          }
          console.log(params);
          if (params.length > 0) {
            this.saveLoding = true;
            const addParams = this.selectionData.map((item) => {
              return this.checkList.includes(item.id)
                ? { id: item.id, autoActivate: 1 }
                : { id: item.id, autoActivate: 0 };
            });
            addConfirmApi(addParams)
              .then((res) => {
                this.$message({
                  type: "success",
                  message: "Add successfully",
                });
                if (addDeviceFrom === "add") {
                  this.activeStep = 0;
                  this.dialogVisible = false;
                } else {
                  this.$emit("addDeviceChildMsg", {
                    close: false,
                    isSave: true,
                  });
                }
                this.saveLoding = false;
              })
              .catch(() => {
                this.saveLoding = false;
              });
          }
        } else {
          this.$message({
            type: "warning",
            message:
              "Please make a selection or click back to the previous page.",
          });
        }
      }
    },

    //设备查询
    handleSearch() {
      return new Promise((resolve, reject) => {
        this.tableLoading = true;
        let params = JSON.parse(JSON.stringify(this.filter));
        params.deviceIdOrSn = params.deviceIdOrSn
          .replace(/\n|\r\n/g, ",")
          .replace(/\s*/g, "");
        params.deviceIdOrSnOrCloudId = params.deviceIdOrSn;
        params.type = this.checkRadio;
        if (this.checkRadio == 1) {
          delete params.orderId;
        }
        addAssetApi(params)
          .then((res) => {
            if (res.msg == "Warning") {
              this.$message({
                type: "warning",
                message:
                  "Warning: Some device IDs do not exist, please check and input them again.",
              });
            }
            this.tableData = res.rows.rows;
            this.checkList = res.rows.rows.map((item) => {
              return item.id;
            });
            this.total = res.rows.total;
            this.tableData.forEach((val) => {
              if (val.bindingFlag == false) {
                this.$nextTick(() => {
                  this.$refs["multipleTable"] &&
                    this.$refs["multipleTable"].toggleRowSelection(val);
                });
              }
            });
            this.tableLoading = false;
            resolve(res.code);
          })
          .catch((err) => {
            this.tableData = [];
            this.total = 0;
            this.tableLoading = false;
            reject(err);
          });
      });
    },

    //返回上一步
    handleBack(data) {
      if (data == 0) {
        this.activeStep = -1;
      } else {
        this.activeStep = 0;
      }
    },

    //表格多选
    handleSelectionChange(data) {
      this.selectionData = data;
    },
    // 是否可选 isBandShow :为0：置灰，为1：显示
    selectable(row) {
      console.log(row, "selectable");
      return row.isBandShow == "1";
    },
    //关闭页面
    closePage(data) {
      this.$emit("addDeviceChildMsg", { close: data, isSave: false });
    },
    // 选择设备
    toggleSelection(tableData) {
      if (tableData && tableData.length != 0) {
        tableData.forEach((row) => {
          // 设备是否已经绑定
          if (row.bindingFlag == false) {
            console.log(row, this.$refs.multipleTable);
            this.$refs.multipleTable &&
              this.$refs.multipleTable.toggleRowSelection(row);
          }
        });
      } else {
        this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
      }
    },
    //添加完成跳转页面
    handleConfirm() {
      if (this.checkJunpRadio == 1) {
        this.activeStep = 0;
        this.dialogVisible = false;
      } else {
        this.dialogVisible = false;
        this.$emit("addDeviceChildMsg", { close: false, isSave: true });
      }
    },
    transform(val) {
      if (!val) {
        this.filter.orderId = "";
      }
    },
  },

  created() {
    this.getCompanyInfor();
    this.defaultFilter = JSON.parse(JSON.stringify(this.filter));
  },
};
</script>

<style lang="scss">
.el-tooltip__popper {
  max-width: 300px;
}
</style>
<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 0 20px !important;
  word-break: normal !important;
}
.sp_addDevice {
  .sp_content {
    width: 100%;
    background: #fff;
    overflow: auto;
    .progress-bar {
      height: 50px;
      display: flex;
      margin: 8px 0;
      align-items: center;
      /deep/.el-step__title {
        height: 20px !important;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .line {
      height: 16px;
      border-bottom: 1px solid #e9edf2;
      margin: 0 4px;
    }
    .message-svg {
      margin-right: 5px;
    }
    .sp_deviceStep1 {
      .sp_deviceRadio {
        width: 400px;
        padding: 5px;
        border-radius: 4px;
        border: 1px solid #ddd;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          font-size: 14px;
          font-weight: 400;
          color: #2b2b2b;
        }
        .el-icon-check {
          font-size: 20px;
          margin-left: 8px;
          color: #007aff;
        }
      }
      .footer {
        text-align: right;
        margin-top: 159px;
        height: 64px;
        line-height: 64px;
      }
      .support {
        margin: 0 106px;
        color: #77808c;
        font-size: 14px;
        line-height: 24px;
        display: flex;
        background-color: #f5f6fa;
        padding: 0 5px;
        .message-svg {
          height: 16px;
          width: 16px;
          margin-right: 5px;
        }
      }
      .is_checked {
        background: rgba($color: #007aff, $alpha: 0.1);
        border-color: #007aff;
        span {
          color: #007aff;
        }
      }
    }
    .addDeviceFrom {
      margin-top: 30px;
      .add-content {
        margin: 0 auto;
        width: 700px;
        /deep/.el-textarea__inner {
          width: 700px;
          padding: 6px 12px;
        }
        /deep/.el-input__inner {
          width: 700px;
          padding: 6px 12px;
          height: 32px;
        }
        .el-form-item {
          margin-bottom: 16px;
        }
        /deep/.el-form-item__label {
          height: 20px !important;
          line-height: 0.7 !important;
          font-size: 14px !important;
          text-align: left;
          display: flex;
        }
        /deep/ .el-checkbox__label {
        }
      }
      .second-footer {
        margin-top: 30px;
        height: 64px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-form-item {
          margin: 0 !important;
        }
      }
    }
    .sp_deviceStep3 {
      position: relative;
      margin-top: 16px;
      .device-table {
        // height: 355px;
      }
      .pagination {
        height: 40px;
        margin-bottom: 64px;
        text-align: right;
        /deep/.el-pager li.disabled {
          color: #ffffff !important;
        }
      }
      .third-footer {
        position: absolute;
        bottom: 16px;
        right: 0;
        margin-top: 16px;
        text-align: right;
      }
    }
    // /deep/.el-step__title {
    //   color: black !important;
    //   font-weight: 600 !important;
    // }
    /deep/.el-step__head.is-success {
      color: #007aff;
      border-color: #007aff;
      .el-step__line {
        background: #007aff;
      }
    }
    /deep/.el-step__head.is-process {
      color: #fff;
      border-color: #007aff;
      .el-step__icon.is-text {
        background: #007aff;
      }
    }
  }

  .checkJunpRadio {
    width: 100%;
    /deep/.el-col-24 {
      padding: 10px;
      margin-bottom: 10px;
      border-radius: 4px;
    }
    .activeJunpRadio {
      background: rgba($color: #2684ff, $alpha: 0.2);
    }
  }
}
/deep/.el-step__title.is-wait {
  color: #545c66 !important;
  font-weight: 400 !important;
}
/deep/.el-step__title.is-process {
  color: #333940 !important;
  font-weight: 500 !important;
}
/deep/.el-step__title.is-success {
  color: #333940 !important;
  font-weight: 500 !important;
}
/deep/.el-step__icon-inner {
  font-weight: 500 !important;
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
/deep/.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  margin-left: -10px !important;
}
</style>
